const mediaWrapper = document.querySelector('.hero__media')
if (mediaWrapper) {
  const videoSrc = mediaWrapper.getAttribute('data-video-src')
  if (videoSrc) {
    window.addEventListener('DOMContentLoaded', () => {
      const video = document.createElement('video')
      video.src = videoSrc
      video.playsinline = true
      video.autoplay = true
      video.muted = true
      video.loop = true
      video.preload = 'data'
      mediaWrapper.appendChild(video)
    })
  }
}
